<template>
  <v-container fluid>

    <v-row>
      <div class='header'>
        <h2>Управление индексами рода.</h2>
      </div>

      <div class='horizontal-rule' />
    </v-row>

    <GenusIndexManageComponent />

  </v-container>
</template>

<script>
import GenusIndexManageComponent from "@/components/GenusIndexManageComponents/GenusIndexManageComponent.vue"

export default {
  name: 'IndexAndGenusManagePage',

  components: {GenusIndexManageComponent},
};
</script>

<style scoped>

</style>